import React, { Fragment, useState } from "react";

import { orderBy } from "lodash";
import { parseISO } from "date-fns";

import lessonStatusToString from "@ds-developer/lesson-status-to-string";

import { CancelLessonModal, LessonNotesModal } from "@hubcapp/components";
import { Lesson } from "@hubcapp/types";
import { useTealium } from "@hubcapp/context";

import { LessonTableRow, StateProviderProps } from "./types";
import LessonsTable from "./LessonsTable";
import useLearnersLessons from "./hooks/useLearnersLessons";

const LessonsTableStateProvider: React.FC<StateProviderProps> = ({
  learnerId,
}) => {
  const [selectedEditingLesson, setSelectedEditingLesson] = useState<
    LessonTableRow
  >();
  const { data, loading } = useLearnersLessons(learnerId);

  const { trackEvent } = useTealium();
  const handleEditingCompleted = () => setSelectedEditingLesson(undefined);

  const handleCancelClick = (lesson: LessonTableRow) => {
    setSelectedEditingLesson(lesson);
    trackEvent({
      eventCategory: "View Learner - Lesson History",
      eventAction: "Interaction",
      eventLabel: "Cancel Lesson",
    });
  };

  const handleAddNoteClick = (lesson: LessonTableRow) => {
    setSelectedEditingLesson(lesson);
    trackEvent({
      eventCategory: "View Learner - Lesson History",
      eventAction: "Button Click",
      eventLabel: "Add/Edit Lesson Note",
    });
  };

  let lessons = (data?.learner.lessons as Lesson[]) || [];
  lessons = lessons.map(lesson => ({
    ...lesson,
    startDateTime:
      typeof lesson.startDateTime === "string"
        ? parseISO(lesson.startDateTime)
        : lesson.startDateTime,
  }));

  return (
    <Fragment>
      {selectedEditingLesson &&
        (lessonStatusToString(
          selectedEditingLesson?.status,
          selectedEditingLesson?.startDateTime,
        ) !== "Upcoming" ? (
          <LessonNotesModal
            handleCancel={handleEditingCompleted}
            lessonId={selectedEditingLesson.id}
            learnerId={learnerId || ""}
            value={selectedEditingLesson.notes || ""}
          />
        ) : (
          <CancelLessonModal
            lessonId={selectedEditingLesson.id}
            lessonStartDateTime={selectedEditingLesson.startDateTime}
            lessonPrePaid={selectedEditingLesson.paid}
            open
            onCancelClicked={handleEditingCompleted}
            onCompleted={handleEditingCompleted}
          />
        ))}
      <LessonsTable
        loading={loading}
        lessons={orderBy(lessons, ["startDateTime"], ["desc"])}
        handleCancelClick={handleCancelClick}
        handleAddNoteClick={handleAddNoteClick}
      />
    </Fragment>
  );
};

export default LessonsTableStateProvider;
